.sn-typical-users {
  display: flex;
  flex-direction: column;

  &__wrapper {
    display: flex;
    flex-direction: column;
    gap: map-get($spacings, 2xl);
    background-color: var(--color-brand-primary-lightest); // TODO: no exact token
    border-radius: var(--radius-size-lg);
    padding: map-get($spacings, md);

    @include above($breakpoint-desktop) {
      gap: map-get($spacings, 3xl);
      padding: map-get($spacings, xl);
    }

    @include above($breakpoint-desktop-md) {
      padding: map-get($spacings, 2xl);
    }
  }

  &__list {
    display: flex;
    flex-direction: column;
    gap: map-get($spacings, md);
    list-style: none;
    margin: 0;
    margin-bottom: map-get($spacings, xl);
    padding: 0;
  }

  &__item {
    display: flex;
    align-items: baseline;
    gap: map-get($spacings, xs);
    font-weight: 400;
    font-size: map-get($font-sizes, md);
    line-height: map-get($line-heights, lg);
    color: var(--color-text-primary);

    @include above($breakpoint-desktop) {
      font-size: map-get($font-sizes, xl);
    }
  }

  &__check {
    flex-shrink: 0;
    color: var(--color-brand-primary-dark); // TODO: no exact token
    margin-top: 2px; // TODO: no exact token
  }

  &__footer {
    font-weight: 400;
    font-size: map-get($font-sizes, md);
    line-height: map-get($line-heights, lg);
    color: var(--color-text-primary);
    margin: 0;

    @include above($breakpoint-desktop) {
      font-size: map-get($font-sizes, xl);
    }
  }

  .me-heading--4 {
    font-size: map-get($font-sizes, 2xl);

    @include above($breakpoint-desktop) {
      font-size: map-get($font-sizes, 3xl);
    }

    @include above($breakpoint-desktop-md) {
      font-size: map-get($font-sizes, 4xl);
    }
  }

  .me-heading--6 {
    font-size: 24px;
    line-height: 32px;
  }

  .me-text {
    font-size: map-get($font-sizes, md);
    line-height: map-get($line-heights, lg);

    @include above($breakpoint-desktop) {
      font-size: map-get($font-sizes, xl);
    }
  }
}
